import { useContext } from 'react';
import { Store } from './Store';
import { mapStateToProps } from './helpers';

export default function useStore(selector = mapStateToProps) {
  const [state, contextDispatch] = useContext(Store);

  return [selector(state), contextDispatch];
}
